/**
 * Resolve `/api/...` fetch URLs across dev (Next rewrites → MOT API), HTTPS LAN storefront, and production.
 *
 * Server / RSC: always `NEXT_PUBLIC_API_URL` prefix.
 * Browser + `NODE_ENV===development`: same-origin `/api/...` (see `apps/web/next.config.mjs` `rewrites`).
 */
import { browserApiBaseUrl, NEXT_PUBLIC_API_URL } from "@/lib/public-env";

export function apiFetchPath(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  if (!p.startsWith("/api/")) {
    throw new Error(`apiFetchPath expects a path starting with /api/, got: ${path}`);
  }
  if (typeof window === "undefined") {
    return `${NEXT_PUBLIC_API_URL.replace(/\/+$/, "")}${p}`;
  }
  const prefix = browserApiBaseUrl().replace(/\/+$/, "");
  return prefix === "" ? p : `${prefix}${p}`;
}

/**
 * Absolute API URL for EventSource / long-lived streams.
 * Never use same-origin `/api` rewrites — Next can buffer SSE and break typing + live messages.
 */
export function apiStreamUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  if (!p.startsWith("/api/")) {
    throw new Error(`apiStreamUrl expects a path starting with /api/, got: ${path}`);
  }
  let base = NEXT_PUBLIC_API_URL.replace(/\/+$/, "");
  if (typeof window !== "undefined") {
    try {
      const u = new URL(base);
      const host = window.location.hostname.toLowerCase();
      const isLoopback =
        u.hostname === "localhost" ||
        u.hostname === "127.0.0.1" ||
        u.hostname.startsWith("127.");
      const winLoopback =
        host === "localhost" || host === "127.0.0.1" || host.startsWith("127.");
      if (isLoopback && !winLoopback) {
        u.hostname = window.location.hostname;
        base = `${u.origin}${u.pathname}`.replace(/\/+$/, "");
      }
    } catch {
      /* keep base */
    }
  }
  return `${base}${p}`;
}
